export default __webpack_public_path__ + "static/media/MadMenOfBombay.5e8e36a5.png";